import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faReact,
  faHtml5,
  faCss3,
  faJs,
  faVuejs,
  faLaravel,
  faInternetExplorer,
} from '@fortawesome/free-brands-svg-icons';
import CustomHook from './CustomHook';
import AboutSkills from './AboutSkills';

function Skills() {
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  const nextJsIcon = 'https://www.datocms-assets.com/75941/1657707878-nextjs_logo.png';

  const [listSkills] = useState([
    {
      name: 'HTML',
      des: 'HTML (HyperText Markup Language) is the standard language used to create and design web pages. It serves as the foundation of web development, allowing developers to structure content on the web using various elements and tags.',
      icon: faHtml5,
    },
    {
      name: 'CSS + SCSS, Tailwind',
      des: 'CSS (Cascading Style Sheets) is used to style and layout web pages, defining the look and feel of HTML elements. SCSS (Sassy CSS) is a more advanced version of CSS, offering features like variables, nesting, and mixins to make writing and maintaining styles easier and more efficient.',
      icon: faCss3,
    },
    {
      name: 'Javascript + Typescript',
      des: 'JavaScript (JS) is a versatile programming language used for creating dynamic and interactive web content. TypeScript (TS) is a superset of JavaScript that adds static type checking, which helps in catching errors early and improving code maintainability.',
      icon: faJs,
    },
    {
      name: 'ReactJs',
      des: 'React is a JavaScript library for building fast and dynamic user interfaces with reusable components and efficient state management. Its helps to write code more faster and it makes code writing easy for developers.',
      icon: faReact,
    },
    {
      name: 'NextJS',
      des: 'Next.js is a React framework designed to streamline the development of server-side rendered and statically generated web applications. With Next.js, developers can build fast, scalable, and SEO-friendly web applications with ease.',
      icon: nextJsIcon,
    },
  ]);
  return (
    <section className="skills" ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        This is my best skills
      </div>
      <AboutSkills />
      <div className="list">
        {listSkills.map((value, key) => (
          <div className={'item '} key={key} ref={(el) => el && divs.current.push(el)}>
            <FontAwesomeIcon icon={value.icon} />
            {value.name === 'NextJS' && (
              <img width={50} height={50} src={nextJsIcon} alt="next js icon" />
            )}
            <h3>{value.name}</h3>
            <div className="des">{value.des}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
